import { useState, useEffect } from 'react';

export type InvoiceTheme = 'theme1' | 'theme2' | 'theme3' | 'theme4' | 'theme5' | 'theme6';

export interface InvoiceThemeColors {
  headerBg: string;
  accentColor: string;
  accentBg: string;
  titleColor: string;
  noteColor: string;
}

export const invoiceThemes: Record<InvoiceTheme, InvoiceThemeColors> = {
  theme1: {
    headerBg: '#323133', // Dark gray
    accentColor: '#aa8b66', // Brown/tan
    accentBg: '#f5f5f5', // Light gray
    titleColor: '#323133', // Dark gray
    noteColor: '#5d4037', // Dark brown for readability
  },
  theme2: {
    headerBg: '#1e3a5f', // Navy blue
    accentColor: '#4a90e2', // Blue
    accentBg: '#e8f4fd', // Light blue
    titleColor: '#1e3a5f', // Navy blue
    noteColor: '#1565c0', // Dark blue for readability
  },
  theme3: {
    headerBg: '#2d5016', // Dark green
    accentColor: '#6b8e23', // Olive green
    accentBg: '#f0f7ed', // Light green
    titleColor: '#2d5016', // Dark green
    noteColor: '#1b5e20', // Dark green for readability
  },
  theme4: {
    headerBg: '#4a148c', // Deep purple
    accentColor: '#7b1fa2', // Purple
    accentBg: '#f3e5f5', // Light purple
    titleColor: '#4a148c', // Deep purple
    noteColor: '#6a1b9a', // Dark purple for readability
  },
  theme5: {
    headerBg: '#e65100', // Deep orange
    accentColor: '#ff6f00', // Orange
    accentBg: '#fff3e0', // Light orange
    titleColor: '#e65100', // Deep orange
    noteColor: '#bf360c', // Dark orange/brown for readability
  },
  theme6: {
    headerBg: '#c62828', // Deep red
    accentColor: '#d32f2f', // Red
    accentBg: '#ffebee', // Light red/pink
    titleColor: '#c62828', // Deep red
    noteColor: '#b71c1c', // Dark red for readability
  },
};

export function useInvoiceTheme() {
  const [theme, setThemeState] = useState<InvoiceTheme>('theme1');

  // Load theme from localStorage on mount
  useEffect(() => {
    const savedTheme = localStorage.getItem('invoiceTheme') as InvoiceTheme;
    if (savedTheme && ['theme1', 'theme2', 'theme3', 'theme4', 'theme5', 'theme6'].includes(savedTheme)) {
      setThemeState(savedTheme);
    }
  }, []);

  const setTheme = (newTheme: InvoiceTheme) => {
    setThemeState(newTheme);
    localStorage.setItem('invoiceTheme', newTheme);
  };

  const colors = invoiceThemes[theme];

  return { theme, setTheme, colors };
}

